import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Link } from 'react-router-dom'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from '../../styles/typography'

/** Error styles */
export const NoJobTitleFoundContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  width: 100%;

  ${Media.Phone`
    grid-template-columns: repeat(2, 1fr);
  `}
`

export const NoJobtitleInfoBox = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  max-width: 415px;
  width: 100%;
`
export const NoJobTitleFoundBox = styled.div`
  height: 360px;
  background: linear-gradient(to bottom, rgba(247, 249, 252, 1) 0%, rgba(247, 249, 252, 0) 100%);
  border-radius: 16px;
`

export const NoJobTitleFoundTitle = styled.h2`
  ${Typography.M};
  ${FontWeights.Medium};
  text-align: center;
`
export const NoJobTitleFoundDescription = styled.p`
  text-align: center;
`

export const Container = styled.div`
  background-color: ${Colors.White};
  position: relative;
  width: 100%;
`

export const LearningHubCustomLink = styled(Link)`
  display: flex;
  padding: 4px;
  gap: 12px;
  align-items: center;
  will-change: color;
  transition: color 0.1s ease-out;

  &:hover {
    color: ${Colors.Blue60};
  }
`
